import { render } from "./CitasPaciente.vue?vue&type=template&id=3d62d7c0&scoped=true"
import script from "./CitasPaciente.vue?vue&type=script&lang=js"
export * from "./CitasPaciente.vue?vue&type=script&lang=js"

import "./CitasPaciente.vue?vue&type=style&index=0&id=3d62d7c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d62d7c0"]])

export default __exports__